import React from 'react';
import PropTypes from 'prop-types';
import * as icons from 'react-bootstrap-icons';

import styles from './Buttons.module.css';

export const PrimaryButton = ({ block = false, disabled = false, icon = null, iconMargin = 0, inverse = false, marginLeft = false, marginRight = false, marginTop = true, onClick, size = undefined, text = "", type }) => {

  let Icon = null;
  if(icon !== null){
    Icon = icons[icon];
  }

  return (
    <button type={ type } className={"btn " + styles.customButton + " " + ((inverse) ? styles.customPrimaryButtonInverse : styles.customPrimaryButton) + ((marginTop) ? " " + styles.customButtonMT : "") + ((marginLeft) ? " " + styles.customButtonML : "") + ((marginRight) ? " " + styles.customButtonMR : "") + ((block) ? " " + styles.customButtonBlock : "")} onClick={onClick} disabled={disabled}>{ (icon !== null) && <Icon size={size} className={styles.icon} style={{marginRight: `${ iconMargin }px`}} /> }{ text }</button>
  )
}

PrimaryButton.propTypes = {
  block: PropTypes.bool,
  disabled: PropTypes.bool,
  icon: PropTypes.string,
  iconMargin: PropTypes.number,
  inverse: PropTypes.bool,
  marginLeft: PropTypes.bool,
  marginRight: PropTypes.bool,
  marginTop: PropTypes.bool,
  onClick: PropTypes.func,
  size: PropTypes.number,
  text: PropTypes.string,
  type: PropTypes.oneOf(['button', 'submit']).isRequired,
}